import { useRouter } from 'next/router'
import { type FC, useEffect, useRef } from 'react'

import { StyledGptTakeover } from '@/components-page/srp/advertisement/styled'
import { GPT_COMPONENT_ID } from '@/features/advertisement/constants/adSlots'
import { triggerManualAdRefresh } from '@/features/advertisement/utils/triggerManualAdRefresh'
import { useTakeoverDetection } from '@/hooks/useTakeoverDetection'

export const GptTakeover: FC = () => {
  const hasTakeover = useTakeoverDetection(GPT_COMPONENT_ID.TAKEOVER)
  const { asPath } = useRouter()
  const previousAsPath = useRef(asPath)

  useEffect(() => {
    if (previousAsPath.current !== asPath) {
      previousAsPath.current = asPath
      triggerManualAdRefresh(GPT_COMPONENT_ID.TAKEOVER)
    }
  }, [asPath])

  return (
    <StyledGptTakeover
      id={GPT_COMPONENT_ID.TAKEOVER}
      data-testid="gpt-takeover"
      $hasTakeover={hasTakeover}
    />
  )
}
